import { Components, Theme } from '@mui/material/styles';

export const muiRadioOverride: Components<Omit<Theme, 'components'>>['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true
  },
  styleOverrides: {
    root: {
      padding: '4px',
      '&.Mui-focusVisible': {
        outline: '2px solid #000'
      }
    }
  }
};
